"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeDemo = void 0;
var React = __importStar(require("react"));
var moment_1 = __importDefault(require("moment"));
var DatePicker_1 = require("./DatePicker");
var DateRangePicker_1 = require("./DateRangePicker");
var DateTimeDemo = /** @class */ (function (_super) {
    __extends(DateTimeDemo, _super);
    function DateTimeDemo(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            singleDate: undefined,
            rangeDates: undefined,
        };
        return _this;
    }
    DateTimeDemo.prototype.render = function () {
        var tzFormat = '(Z)';
        var timezonetext = (0, moment_1.default)().format(tzFormat);
        return (React.createElement(React.Fragment, null,
            React.createElement("h5", null, "Date Range Picker"),
            React.createElement(DateRangePicker_1.DateRangePicker, { value: '', onChange: this.onChange, showTime: true, applyButtonText: 'Use Dates', clearText: 'Clear Dates', headerStartLabel: 'Open Date / Time', headerEndLabel: 'Close Date / Time', textInputStartPlaceholder: 'Open Date ' + timezonetext, textInputEndPlaceholder: 'Close Date ' + timezonetext, dateInputStartPlaceholder: 'Open Date', dateInputEndPlaceholder: 'Close Date', enabledStartDate: (0, moment_1.default)() }),
            React.createElement("p", { className: 'demo' }, "Example Code"),
            React.createElement("pre", null,
                React.createElement("code", null,
                    "<DateRangePicker value='defaultValue' onChange={this.onChange} showTime={true} clearText='Clear Dates' applyButtonText='Use Dates' ",
                    React.createElement("br", null),
                    "textInputStartPlaceholder='Open Date' textInputEndPlaceholder='Close Date' dateInputStartPlaceholder='Open Date' dateInputEndPlaceholder='Close Date'",
                    React.createElement("br", null),
                    "headerStartLabel='Open Date / Time' headerEndLabel='Close Date / Time' />")),
            React.createElement("h5", null, "Date Picker"),
            React.createElement(DatePicker_1.DatePicker, { value: '', onChange: this.onChange, applyButtonText: 'Use Date', clearText: 'Clear Date', headerLabel: 'Date / Time', textInputPlaceholder: 'Date ' + timezonetext, dateInputPlaceholder: 'Choose Date', enabledStartDate: (0, moment_1.default)() }),
            React.createElement("p", { className: 'demo' }, "Example Code"),
            React.createElement("pre", null,
                React.createElement("code", null,
                    "<DatePicker value='defaultValue' onChange={this.onChange} showTime={true} clearText='Clear Date' applyButtonText='Use Date' ",
                    React.createElement("br", null),
                    "textInputPlaceholder='Date' dateInputPlaceholder='Choose Date' headerLabel='Date / Time' />")),
            React.createElement("h5", null, "Without Clear Date(s) Link And No Header Labels"),
            React.createElement(DateRangePicker_1.DateRangePicker, { value: '', onChange: this.onChange, showTime: true, applyButtonText: 'Use Dates', textInputStartPlaceholder: 'No Open Date', textInputEndPlaceholder: 'No Close Date', dateInputStartPlaceholder: 'Open Date', dateInputEndPlaceholder: 'Close Date', showClear: false }),
            React.createElement("br", null),
            React.createElement(DatePicker_1.DatePicker, { value: '', onChange: this.onChange, showTime: true, applyButtonText: 'Use Date', textInputPlaceholder: 'No Date', dateInputPlaceholder: 'Choose Date', showClear: false }),
            React.createElement("p", { className: 'demo' }, "Example Code"),
            React.createElement("pre", null,
                React.createElement("code", null,
                    "Notes:",
                    React.createElement("br", null),
                    "1. The same codes applied on either components with the addition of showClear props set to false.",
                    React.createElement("br", null),
                    "2. No header labels are displayed if headerLabel, headerStartLabel and headerEndLabel props are empty.")),
            React.createElement("h5", null, "Error State"),
            React.createElement(DateRangePicker_1.DateRangePicker, { value: '', onChange: this.onChange, showTime: true, applyButtonText: 'Use Dates', clearText: 'Clear Dates', textInputStartPlaceholder: 'No open date chosen', textInputEndPlaceholder: 'No close date chosen', dateInputStartPlaceholder: 'Open Date', dateInputEndPlaceholder: 'Close Date', error: true, message: 'Please choose a range of open and close dates' }),
            React.createElement(DatePicker_1.DatePicker, { value: '', onChange: this.onChange, applyButtonText: 'Use Date', clearText: 'Clear Date', textInputPlaceholder: 'No date chosen', dateInputPlaceholder: 'Choose Date', showMinute: false, enableInput: false, error: true, message: ['First error message', 'Second error message'] }),
            React.createElement("p", { className: 'demo' }, "Example Code"),
            React.createElement("pre", null,
                React.createElement("code", null, "Note: use the props 'error' and 'message' to set the error state of the input fields. This is the same ones from the Input component."))));
    };
    DateTimeDemo.prototype.onChange = function (value) {
        //
    };
    return DateTimeDemo;
}(React.Component));
exports.DateTimeDemo = DateTimeDemo;
